import { format, getMonth, getQuarter, getYear, parseISO } from 'date-fns'
import { ContractsValueObjectsAdditionalCompensationRecurrenceEnum } from 'generated/resources/graphql'
import i18n from 'modules/core/lib/i18n'

interface Period {
  startsOn: string
  endsOn: string
}

const QUARTER_START_MONTHS = [0, 3, 6, 9]
const HALF_START_MONTHS = [0, 6]

export const periodLabel = (
  recurrence: ContractsValueObjectsAdditionalCompensationRecurrenceEnum,
  period: Period
): string => {
  const startDate = parseISO(period.startsOn)
  const endDate = parseISO(period.endsOn)
  const startMonth = getMonth(startDate)

  switch (recurrence) {
    case 'monthly':
      return format(startDate, 'MMMM')

    case 'every_3_months': {
      if (QUARTER_START_MONTHS.includes(startMonth)) {
        return i18n.t('incentives.period.quarter', { quarter: getQuarter(startDate) })
      }
      return formatDateRange(startDate, endDate)
    }

    case 'every_6_months': {
      if (HALF_START_MONTHS.includes(startMonth)) {
        const half = startMonth === 0 ? 1 : 2
        return i18n.t('incentives.period.half', { half })
      }
      return formatDateRange(startDate, endDate)
    }

    case 'every_12_months':
      return String(getYear(startDate))

    default:
      return formatDateRange(startDate, endDate)
  }
}

const formatDateRange = (startDate: Date, endDate: Date): string => {
  const startMonth = format(startDate, 'MMM')
  const endMonth = format(endDate, 'MMM')
  const startYear = getYear(startDate)
  const endYear = getYear(endDate)

  if (startYear === endYear) {
    return `${startMonth} - ${endMonth} ${startYear}`
  }

  return `${startMonth} ${startYear} - ${endMonth} ${endYear}`
}
